import { pgTable, uuid, text, timestamp, numeric, jsonb, index } from "drizzle-orm/pg-core";
import { organisations } from "./organisations";
export var FactMetricName;
(function (FactMetricName) {
    FactMetricName["MRR"] = "mrr";
    FactMetricName["CHURN_RATE"] = "churn_rate";
    FactMetricName["ACTIVE_USERS"] = "active_users";
    FactMetricName["CONVERSION_RATE"] = "conversion_rate";
    FactMetricName["CASH_IN_BANK"] = "cash_in_bank";
    FactMetricName["MONTHLY_BURN"] = "monthly_burn";
    FactMetricName["ACTIVATION_RATE"] = "activation_rate";
    FactMetricName["RETENTION_RATE"] = "retention_rate";
    FactMetricName["FUNNEL_CONVERSION"] = "funnel_conversion";
    /** Sum of daily unique signups (activation event) over 7d — upper-bound style proxy. */
    FactMetricName["WEEKLY_SIGNUPS"] = "weekly_signups";
    /** Peak DAU / peak WAU-style proxy from segmentation (documented in metadata). */
    FactMetricName["STICKINESS_DAU_WAU"] = "stickiness_dau_wau";
    /** Peak DAU / peak MAU-style proxy over 30d window. */
    FactMetricName["STICKINESS_DAU_MAU"] = "stickiness_dau_mau";
    /** Mean hours to last funnel step when saved Mixpanel funnel exists. */
    FactMetricName["TIME_TO_VALUE_HOURS"] = "time_to_value_hours";
    /** key_feature uniques / core uniques same window. */
    FactMetricName["FEATURE_ADOPTION_RATE"] = "feature_adoption_rate";
    /** failure event totals / active proxy. */
    FactMetricName["ERROR_RATE_PER_ACTIVE"] = "error_rate_per_active";
    /** general event count / unique users (core) over window. */
    FactMetricName["EVENTS_PER_ACTIVE_USER"] = "events_per_active_user";
    /** Reserved; v1 may omit write if API insufficient. */
    FactMetricName["RESURRECTION_RATE"] = "resurrection_rate";
    /** Weekly uniques on north_star event. */
    FactMetricName["NORTH_STAR_WAU"] = "north_star_wau";
})(FactMetricName || (FactMetricName = {}));
/**
 * facts_metric: stores raw numeric facts (e.g., mrr, churn_rate) over time
 * Use dims for optional dimensions (plan, region, segment, etc.)
 */
export const factsMetric = pgTable("facts_metric", {
    id: uuid("id").primaryKey().defaultRandom(),
    companyId: uuid("company_id")
        .notNull()
        .references(() => organisations.id, { onDelete: "cascade" }),
    name: text("name").notNull().$type(), // metric name: mrr, churn_rate, active_users, conversion_rate
    ts: timestamp("ts", { withTimezone: true }).notNull(),
    value: numeric("value", { precision: 18, scale: 6 }).notNull(),
    metadata: jsonb("metadata").notNull().default({}),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
}, table => ({
    companyMetricTsIdx: index("idx_facts_metric_company_name_ts").on(table.companyId, table.name, table.ts),
}));
